module.exports = __webpack_public_path__ + "img/OrganizationManagement.7c8792d9.svg";